import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import {
  Grid, Paper, Button, TextField, FormControl,
  Chip, Select, MenuItem, Input, Typography,
  FormControlLabel, Card, Grow, Fab,
  InputBase, ListItem, Divider, ListItemText,
  ListItemSecondaryAction, IconButton, List,
  InputLabel
} from '@material-ui/core'

import {
  Delete as DeleteIcon, Search as SearchIcon
} from '@material-ui/icons'

import Autocomplete from '@material-ui/lab/Autocomplete'

import { useTheme } from '@material-ui/core/styles'
import { getSearchResults } from '../../../../redux/actions'
import { NotificationToast } from '../../tools/Toast'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

let indexNum = 0
let stationIndex = 0

const UserBuildAlertsForm = (props) => {
  const {
    classes, StyledSwitch, AccessSwitch, CustomSlider,
    CustomTextField, formData, setFormData, selectedKey,
    GreenCheckbox, marks, UsersList, Categories,
    WorkstationsList
  } = props
  const theme = useTheme()

  const dispatch = useDispatch()

  const [dense] = useState(true)

  const onChange = (prop) => e => {
    e.preventDefault()
    if (prop === 'phrase') {
      setPhraseInput(e.target.value)
    }
    setFormData({ ...formData, [prop]: e.target.value })
  }

  const setSource = (value) => {
    if (value === 'all') {
      const newForm = { ...formData }
      newForm.keyboard = 1
      newForm.application = 1
      setFormData(newForm)
    } else if (value === 'keyboard') {
      const newForm = { ...formData }
      newForm.keyboard = 1
      newForm.application = 0
      setFormData(newForm)
    } else if (value === 'application') {
      const newForm = { ...formData }
      newForm.keyboard = 0
      newForm.application = 1
      setFormData(newForm)
    }
  }

  const setCategories = (e) => {
    const categories = [...e.target.value]
    categories.forEach(category => {
      delete category.accountID
      delete category.categoryDesc
    })
    setFormData({ ...formData, categories })
  }

  // const clearCategories = (category) => {
  //   const categories = [...formData.categories]
  //   const categoriesArray = categories.filter((categoryInfo) => categoryInfo.categoryID !== category.categoryID)
  //   setFormData({ ...formData, categories: categoriesArray })
  // }

  const handleDeleteCategories = (category) => {
    const categories = [...formData.categories]
    const newCategory = categories.filter((categoryInfo) => categoryInfo.categoryID !== category.categoryID)
    setFormData({ ...formData, categories: newCategory })
  }

  const getStyles = (category, categoryArray, theme) => {
    return {
      fontWeight:
        categoryArray.indexOf(category) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium
    }
  }

  const handleAddUser = (e, user) => {
    const newUser = user[indexNum++]
    const users = [...formData.usernames]
    const index = users.indexOf(newUser)
    if (index === -1) {
      users.push(newUser)
    }
    setFormData({ ...formData, usernames: users })
  }
  const handleDeleteUser = (user) => {
    indexNum--
    const users = [...formData.usernames]
    const newuser = users.filter(entry => entry !== user)
    setFormData({ ...formData, usernames: newuser })
  }

  const handleAddStation = (e, station) => {
    const newStation = station[stationIndex++]
    const stations = [...formData.workstations]
    const index = stations.indexOf(newStation)
    if (index === -1) {
      stations.push(newStation)
    }
    setFormData({ ...formData, workstations: stations })
  }
  const handleDeleteStation = (station) => {
    stationIndex--
    const stations = [...formData.workstations]
    const newStation = stations.filter(entry => entry !== station)
    setFormData({ ...formData, workstations: newStation })
  }

  const toggleCountReset = () => {
    const newForm = { ...formData }
    newForm.resetCount = !newForm.resetCount
    setFormData(newForm)
  }

  const togglePublicPrivate = () => {
    const newForm = { ...formData }
    newForm.privateAlert = !newForm.privateAlert
    setFormData(newForm)
  }

  const handleSliderChange = (event, newValue) => {
    setFormData({ ...formData, minSeverity: newValue[0], maxSeverity: newValue[1] })
  }

  const handleUsersToggle = () => {
    const newForm = { ...formData }
    newForm.groupByUser = !newForm.groupByUser
    setFormData(newForm)
  }

  const handleWorkstationsToggle = () => {
    const newForm = { ...formData }
    newForm.groupByWorkstation = !newForm.groupByWorkstation
    setFormData(newForm)
  }

  const handleTimeframeToggle = () => {
    if (formData.limitByTimeframe === 0) {
      setFormData({ ...formData, limitByTimeframe: 1 })
    } else {
      setFormData({ ...formData, limitByTimeframe: 0, timeframe: 0 })
    }
  }

  const handleTypeToggle = (e) => {
    if (e.target.value === 'S') {
      setFormData({ ...formData, type: 'S', words: [] })
      setPhraseInput('')
    } else if (e.target.value === 'W') {
      setFormData({ ...formData, type: 'W', minSeverity: 1, maxSeverity: 100 })
    }
  }

  const [phraseInput, setPhraseInput] = useState('')

  const handleSearch = async () => {
    if (!phraseInput.match(/^[^.\s]/)) {
      NotificationToast(true, 'Phrase cannot contain spaces at the beginning of the line.')
    } else {
      const unitID = selectedKey
      const searchText = phraseInput
      dispatch(getSearchResults(unitID, searchText, fireFound, fireNotFound))
    }
  }

  const fireFound = (data) => {
    const { phrase, wordID } = data
    if (formData.words.some(word => word.wordID === wordID)) {
      NotificationToast(true, 'This word has already been added.')
      setPhraseInput('')
    } else {
      NotificationToast(false, 'Word has successfully been added to this alert!')
      const newForm = { ...formData }
      newForm.words.unshift({ phrase, wordID })
      setFormData(newForm)
      setPhraseInput('')
    }
  }

  const fireNotFound = () => {
    NotificationToast(true, 'This word does not exist.')
  }

  const handleWordDelete = (wordID, index) => {
    const newForm = { ...formData }
    newForm.words.splice(index, 1)
    setFormData(newForm)
  }

  return (
    <>
      <Paper elevation={2} className={classes.editPaper}>
        <Grid
          container
          direction='column'
          justify='center'
          className={`px-3 w-100 py-3 mx-auto my-auto ${classes.buildAlertsContainer}`}
          spacing={2}
        >
          <Grid container item direction='row' alignContent='center' className=''>

            <Grid item xs={6}>
              <Typography variant='h4' color='primary' className='font-weight-bold' classes={{ colorPrimary: classes.greyColor }}>Alert Builder</Typography>
            </Grid>

            <Grid item xs={6}>
              <Grid item container direction='row' justify='flex-end'>
                <Typography component='div'>
                  <Grid component='label' container alignItems='center' spacing={1}>
                    <Grid item>
                      <Typography style={{ fontSize: '.8rem', fontWeight: 'bold' }} classes={{ colorPrimary: classes.greyColor }} color='primary'>Public</Typography>
                    </Grid>
                    <Grid item>
                      <AccessSwitch
                        checked={!!formData.privateAlert}
                        onClick={togglePublicPrivate}
                      />
                    </Grid>
                    <Grid item>
                      <Typography style={{ fontSize: '.8rem', fontWeight: 'bold' }} classes={{ colorPrimary: classes.greyColor }} color='primary'>Private</Typography>
                    </Grid>
                  </Grid>
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Alert Name */}
          <Grid item container direction='row'>
            <Grid container item direction='column'>

              <Grid container item direction='row'>
                <Typography
                  variant='h6'
                  color='primary'
                  classes={{ colorPrimary: classes.greyColor }}
                  className='font-weight-bold'
                >
                  Alert Name
                </Typography>
              </Grid>

              <Grid container item direction='row' className='px-3'>
                <Card className='mb-2 px-3 py-2 w-100'>
                  <Grid item container direction='row' className='my-2'>
                    <FormControl className='w-100'>
                      <CustomTextField
                        label='Alert Name'
                        required
                        name='emailNotificationName'
                        variant='outlined'
                        // variant='filled'
                        error={formData.emailNotificationName.length === 0}
                        value={formData.emailNotificationName ? formData.emailNotificationName : ''}
                        onChange={onChange('emailNotificationName')}
                        fullWidth
                      />
                    </FormControl>
                  </Grid>
                </Card>
              </Grid>

            </Grid>
          </Grid>

          {/* Alert Description */}
          <Grid item container direction='row'>
            <Grid container item direction='column'>

              <Grid container item direction='row'>
                <Typography
                  variant='h6'
                  color='primary'
                  classes={{ colorPrimary: classes.greyColor }}
                  className='font-weight-bold'
                >
                  Alert Description
                </Typography>
              </Grid>

              <Grid container item direction='row' className='px-3'>
                <Card className='mb-2 px-3 w-100 py-2'>
                  <Grid item container direction='row' className='my-2'>
                    <FormControl className='w-100'>
                      <CustomTextField
                        label='Alert Description'
                        required
                        name='emailNotificationDesc'
                        multiline
                        rows={2}
                        variant='outlined'
                        // variant='filled'
                        error={formData.emailNotificationDesc.length === 0}
                        value={formData.emailNotificationDesc ? formData.emailNotificationDesc : ''}
                        onChange={onChange('emailNotificationDesc')}
                        fullWidth
                      />
                    </FormControl>
                  </Grid>
                </Card>
              </Grid>

            </Grid>
          </Grid>

          {/* Alert Type */}
          <Grid item container direction='row'>
            <Grid item container direction='column'>

              <Grid item container direction='row'>
                <Typography
                  variant='h6'
                  color='primary'
                  classes={{ colorPrimary: classes.greyColor }}
                  className='font-weight-bold'
                >
                  Type
                </Typography>
              </Grid>

              <Grid item container direction='row' className='px-3'>
                <Card className='mb-2 mx-auto px-3 w-100'>
                  <Grid container direction='row'>

                    <Grid item container justify='center' xs={6}>
                      <Typography
                        variant='h6'
                        color='primary'
                        classes={{ colorPrimary: classes.greyColor }}
                        className='my-auto'
                      >
                        Severity
                      </Typography>
                      <GreenCheckbox
                        className='ml-3'
                        value='S'
                        onChange={(e) => handleTypeToggle(e)}
                        checked={formData.type === 'S'}
                      />
                    </Grid>

                    <Grid item container justify='center' xs={6}>
                      <Typography
                        variant='h6'
                        color='primary'
                        classes={{ colorPrimary: classes.greyColor }}
                        className='my-auto'
                      >
                        Words
                      </Typography>
                      <GreenCheckbox
                        className='ml-3'
                        value='W'
                        onChange={(e) => handleTypeToggle(e)}
                        checked={formData.type === 'W'}
                      />
                    </Grid>

                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          {
            formData.type === 'S'
              ? (
                <>
                  {/* Severity */}
                  <Grid container item direction='row'>
                    <Grid container item direction='column'>

                      <Grid item container direction='row'>
                        <Typography
                          variant='h6'
                          color='primary'
                          classes={{ colorPrimary: classes.greyColor }}
                          className='font-weight-bold'
                        >
                          Severity
                        </Typography>
                      </Grid>

                      <Grid item container direction='row' className='px-3'>
                        <Card className='mb-2 w-100 py-2'>
                          <Grid container direction='column' className='px-3'>

                            <Grid item container direction='row' className='mb-0'>
                              <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                                Set a custom severity range for this alert.
                              </Typography>
                            </Grid>

                            <Grid item container direction='row' justify='center' className='mb-0'>
                              <Grid item xs={10}>
                                <CustomSlider
                                  className='mt-5'
                                  value={[formData.minSeverity, formData.maxSeverity]}
                                  onChange={handleSliderChange}
                                  aria-labelledby='range-slider'
                                  min={1}
                                  max={100}
                                  marks={marks}
                                  valueLabelDisplay='on'
                                />
                              </Grid>
                            </Grid>

                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  {/* Words */}
                  <Grid container item direction='row'>
                    <Grid container item direction='column'>

                      <Grid item container direction='row'>
                        <Typography
                          variant='h6'
                          color='primary'
                          classes={{ colorPrimary: classes.greyColor }}
                          className='font-weight-bold'
                        >
                          Words
                        </Typography>
                      </Grid>

                      <Grid item container direction='row' className='px-3'>
                        <Card className='mb-2 w-100'>
                          <Grid container direction='column' className='px-3'>
                            <Grid item container direction='row' className='mb-0'>
                              <Grid item xs={10}>
                                <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                                  Add a list of custom words for this alert.
                                </Typography>
                              </Grid>
                            </Grid>
                            {/* <Grow in={tableSevOpen} timeout={500} onExited={() => setSevTableHide(true)}>
                                <Col> */}

                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item>
                                  <Typography
                                    variant='h6'
                                    color='primary'
                                    classes={{ colorPrimary: classes.greyColor }}
                                    className='font-weight-bold mt-2'
                                  >
                                    Search
                                  </Typography>
                                </Grid>

                                <Grid
                                  container
                                  direction='row'
                                  spacing={2}
                                  className='w-100 mx-auto mb-2 px-2'
                                  name='sourceGroup'
                                  id='sourceGroup'
                                  style={{ marginBottom: '10px' }}
                                >
                                  <Grid item xs={12}>
                                    <div className={classes.search}>
                                      <div className={classes.searchIcon}>
                                        <Fab
                                          className={classes.searchBtn}
                                          size='small'
                                          onClick={handleSearch}
                                        >
                                          <SearchIcon />
                                        </Fab>
                                      </div>
                                      <InputBase
                                        placeholder='Search Phrase'
                                        classes={{
                                          root: classes.inputRoot,
                                          input: classes.inputInput
                                        }}
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={onChange('phrase')}
                                        value={phraseInput}
                                        onBlur={handleSearch}
                                      />
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>

                              {
                                formData.words.length > 0
                                  ? (
                                    <>
                                      <Grid item container direction='row' style={{ height: '170px', overflow: 'scroll' }}>
                                        <Grid item xs={12}>
                                          <List dense={dense} className={classes.wordList}>
                                            {formData.words.map((word, index) => {
                                              return (
                                                <React.Fragment key={word.wordID}>
                                                  <ListItem>
                                                    <ListItemText
                                                      style={{ fontWeight: 'bold' }}
                                                      primary={word.phrase}
                                                    />
                                                    <ListItemSecondaryAction>
                                                      <IconButton
                                                        edge='end'
                                                        aria-label='delete'
                                                        onClick={(e) => { e.preventDefault(); handleWordDelete(word.wordID, index) }}
                                                      >
                                                        <DeleteIcon />
                                                      </IconButton>
                                                    </ListItemSecondaryAction>
                                                  </ListItem>
                                                  <Divider variant='middle' />
                                                </React.Fragment>
                                              )
                                            })}
                                          </List>
                                        </Grid>
                                      </Grid>
                                    </>
                                  ) : (
                                    <>
                                    </>
                                  )
                              }

                              {/* Sources */}
                              <Grid container>
                                <Grid item>
                                  <Typography
                                    variant='h6'
                                    color='primary'
                                    classes={{ colorPrimary: classes.greyColor }}
                                    className='font-weight-bold'
                                  >
                                    Sources
                                  </Typography>
                                </Grid>

                                <Grid
                                  container
                                  direction='row'
                                  spacing={2}
                                  className='w-100 mx-auto mb-2 px-2'
                                  name='sourceGroup'
                                  id='sourceGroup'
                                  style={{ marginBottom: '10px' }}
                                >
                                  <Grid item>
                                    <Button
                                      variant='contained'
                                      id='keyboard'
                                      color='primary'
                                      classes={{ containedPrimary: formData.keyboard === 1 && formData.application === 0 ? classes.blueBackground : classes.greenBackground }}
                                      onClick={() => setSource('keyboard')}
                                      style={{ marginRight: '10px' }}
                                    >
                                      Keyboard
                                    </Button>
                                    <Button
                                      variant='contained'
                                      id='application'
                                      color='primary'
                                      classes={{ containedPrimary: formData.keyboard === 0 && formData.application === 1 ? classes.blueBackground : classes.greenBackground }}
                                      onClick={() => setSource('application')}
                                      style={{ marginRight: '10px' }}
                                    >
                                      Application
                                    </Button>
                                    <Button
                                      variant='contained'
                                      id='all'
                                      color='primary'
                                      classes={{ containedPrimary: formData.keyboard === 1 && formData.application === 1 ? classes.blueBackground : classes.greenBackground }}
                                      onClick={() => setSource('all')}
                                    >
                                      All
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* </Col>
                              </Grow> */}
                          </Grid>
                        </Card>
                      </Grid>

                    </Grid>
                  </Grid>
                </>
              )
          }

          {/* Categories */}
          <Grid container item direction='row'>
            <Grid item container direction='column'>

              <Grid item container direction='row'>
                <Typography
                  variant='h6'
                  color='primary'
                  classes={{ colorPrimary: classes.greyColor }}
                  className='font-weight-bold'
                >
                  Categories
                </Typography>
              </Grid>

              <Grid item container direction='row' className='px-3'>
                <Card className='mb-2 w-100 py-2'>
                  <Grid container direction='column' className='px-3'>

                    <Grid item container direction='row' className='mb-0'>
                      <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                        Select specific categories to set for this alert.
                      </Typography>
                    </Grid>

                    <Grid item container direction='row' className='mb-0 mt-2'>
                      <FormControl fullWidth>
                        <InputLabel id='category-multi-select'>Select Categories</InputLabel>
                        <Select
                          labelId='category-multi-select'
                          label='Select Categories'
                          id='categories'
                          className='mb-2'
                          multiple
                          value={formData.categories}
                          onChange={setCategories}
                          input={<Input id='Categories' classes={{ underline: classes.underline }} />}
                          renderValue={(selected) => (
                            <div className={classes.chips}>
                              {selected.map((categoryValue, index) => (
                                <Chip
                                  key={index}
                                  label={categoryValue.categoryName}
                                  className={classes.chip}
                                  onMouseDown={(e) => { e.stopPropagation() }}
                                  onDelete={() => handleDeleteCategories(categoryValue)}
                                />
                              ))}
                            </div>
                          )}
                          MenuProps={MenuProps}
                        >
                          {Categories.map((category) => (
                            <MenuItem key={category.categoryID} value={category} style={getStyles(category.categoryName, Categories, theme)}>
                              {category.categoryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                  </Grid>
                </Card>
              </Grid>

            </Grid>
          </Grid>

          {/* Users */}
          <Grid container item direction='row'>
            <Grid container item direction='column'>

              <Grid item container direction='row'>
                <Typography
                  variant='h6'
                  className='font-weight-bold'
                  color='primary'
                  classes={{ colorPrimary: classes.greyColor }}
                >
                  Users
                </Typography>
              </Grid>

              <Grid item container direction='row' className='px-3'>
                <Card className='mb-2 w-100 py-2'>
                  <Grid container direction='column' className='px-3'>

                    <Grid item container direction='row' className='mb-0'>
                      <Grid item xs={12}>
                        <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                          Start typing a specific users name to find and add them for this alert.
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid item container direction='row' className='mb-0 mt-2'>
                      <Autocomplete
                        multiple
                        fullWidth
                        filterSelectedOptions
                        id='users-select'
                        options={UsersList}
                        value={formData.usernames}
                        getOptionLabel={(option) => option.username}
                        onChange={(e, newValue) => handleAddUser(e, newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant='standard'
                            label='Select Users'
                            className='mb-2'
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          formData.usernames.map((user, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              variant='outlined'
                              key={`user-${user.username}`}
                              label={user.username}
                              onDelete={() => handleDeleteUser(user)}
                            />
                          ))}
                      />
                    </Grid>

                  </Grid>
                </Card>
              </Grid>

            </Grid>
          </Grid>

          {/* Workstations */}
          <Grid container item direction='row'>
            <Grid container item direction='column'>

              <Grid item container direction='row'>
                <Typography
                  variant='h6'
                  className='font-weight-bold'
                  color='primary'
                  classes={{ colorPrimary: classes.greyColor }}
                >
                  Workstations
                </Typography>
              </Grid>

              <Grid container item direction='row' className='px-3'>
                <Card className='mb-2 w-100 py-2'>
                  <Grid container direction='column' className='px-3'>

                    <Grid item container direction='row' className='mb-0'>
                      <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                        Start typing a specific workstation name to find and add it for this alert.
                      </Typography>
                    </Grid>

                    <Grid item container direction='row' className='mb-0 mt-2'>
                      <Autocomplete
                        multiple
                        fullWidth
                        filterSelectedOptions
                        id='workstations-select'
                        options={WorkstationsList}
                        value={formData.workstations}
                        getOptionLabel={(option) => option.hostname}
                        onChange={(e, newValue) => handleAddStation(e, newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant='standard'
                            label='Select Workstations'
                            className='mb-2'
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          formData.workstations.map((station, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              variant='outlined'
                              key={`station-${station.workstationID}`}
                              label={station.hostname}
                              onDelete={() => handleDeleteStation(station)}
                            />
                          ))}
                      />
                    </Grid>

                  </Grid>
                </Card>
              </Grid>

            </Grid>
          </Grid>

          {/* Timeframe */}
          <Grid container item direction='row'>
            <Grid container item direction='column'>

              <Grid item container direction='row'>
                <Typography
                  variant='h6'
                  color='primary'
                  classes={{ colorPrimary: classes.greyColor }}
                  className='font-weight-bold'
                >
                  Timeframe
                </Typography>
              </Grid>

              <Grid item container direction='row' className='px-3'>
                <Card className='mb-2 w-100 py-2'>
                  <Grid container direction='column' className='px-3'>

                    <Grid item container direction='row' className='mb-0'>
                      <Grid item xs={10}>
                        <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                          If enabled, a timeframe can be set for this alert.
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <GreenCheckbox
                          className='ml-3'
                          value='severity'
                          onChange={handleTimeframeToggle}
                          checked={!!formData.limitByTimeframe}
                        />
                      </Grid>
                    </Grid>

                    <Grow in={formData.limitByTimeframe === 1 || formData.limitByTimeframe === true} timeout={500} unmountOnExit>
                      <Grid container direction='column'>

                        <Grid item container direction='row' className='mb-0 mt-2'>
                          <FormControl className='mb-2' fullWidth>
                            <CustomTextField
                              label='Number Of Minutes'
                              type='number'
                              // InputProps={{
                              //   inputProps: {
                              //     max: 100, min: 0
                              //   }
                              // }}
                              // required
                              name='timeframe'
                              variant='outlined'
                              // variant='filled'
                              // error={formData.timeframe.length === 0}
                              value={formData.timeframe ? formData.timeframe : ''}
                              onChange={onChange('timeframe')}
                              fullWidth
                            />
                          </FormControl>
                        </Grid>

                        <Grid item container direction='row' className='mb-0 mt-3'>
                          <Grid item xs={6}>
                            <FormControl fullWidth>
                              <CustomTextField
                                label='Reset Count Number'
                                type='number'
                                InputProps={{
                                  inputProps: {
                                    max: 100, min: 0
                                  }
                                }}
                                // required
                                name='count'
                                variant='outlined'
                                // variant='filled'
                                // error={formData.count.length === 0}
                                value={formData.count ? formData.count : ''}
                                onChange={onChange('count')}
                                fullWidth
                              />
                            </FormControl>
                          </Grid>

                          <Grid item xs={6}>
                            <Grid item container justify='center'>
                              <Typography
                                variant='body1'
                                component='label'
                                color='primary'
                                className='font-weight-bold'
                                classes={{ colorPrimary: classes.greyColor }}
                              >
                                Clear Counter
                              </Typography>
                            </Grid>

                            <Grid item container justify='center'>
                              <FormControlLabel
                                label={formData.resetCount ? 'Enabled' : 'Disabled'}
                                control={
                                  <StyledSwitch
                                    checked={!!formData.resetCount}
                                    onClick={toggleCountReset}
                                  />
                                }
                                labelPlacement='end'
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item container direction='row' className='mb-0 mt-3'>
                          <Grid item xs={5} container direction='column'>

                            <Grid item container justify='center' direction='row'>
                              <Typography
                                variant='body1'
                                component='label'
                                color='primary'
                                className='font-weight-bold'
                                classes={{ colorPrimary: classes.greyColor }}
                                style={{ fontSize: '.9rem' }}
                              >
                                Group By Users
                              </Typography>
                            </Grid>

                            <Grid item container justify='center' direction='row'>
                              <FormControlLabel
                                label={formData.groupByUser ? 'Enabled' : 'Disabled'}
                                control={
                                  <StyledSwitch
                                    checked={!!formData.groupByUser}
                                    onClick={handleUsersToggle}
                                  />
                                }
                                labelPlacement='end'
                              />
                            </Grid>

                          </Grid>

                          <Grid item xs={7} container direction='column'>

                            <Grid item container justify='center' direction='row'>
                              <Typography
                                variant='body1'
                                component='label'
                                color='primary'
                                className='font-weight-bold'
                                classes={{ colorPrimary: classes.greyColor }}
                                style={{ fontSize: '.9rem' }}
                              >
                                Group By Workstations
                              </Typography>
                            </Grid>

                            <Grid item container justify='center' direction='row'>
                              <FormControlLabel
                                label={formData.groupByWorkstation ? 'Enabled' : 'Disabled'}
                                control={
                                  <StyledSwitch
                                    checked={!!formData.groupByWorkstation}
                                    onClick={handleWorkstationsToggle}
                                  />
                                }
                                labelPlacement='end'
                              />
                            </Grid>

                          </Grid>
                        </Grid>
                      </Grid>
                    </Grow>
                  </Grid>
                </Card>
              </Grid>

            </Grid>
          </Grid>

        </Grid>
      </Paper>
    </>
  )
}

export default UserBuildAlertsForm
